import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


export function formatCurrency(value) {
  if (value == null || isNaN(value)) return "0,00";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(value);
}

export function formatDate(dateStr) {
  if (!dateStr) return "-";
  return dateStr;
}
